import { Button } from "antd";
import "./style.css";

const ActionButton = ({ label, size }) => {
  return (
    <Button className={`action-button button-${size || "default"}`}>
      <p className="button-label">{label || "Actions"}</p>
      <img
        className="action-arrow"
        src="/assets/icons/black-down-arrow.svg"
        alt="down-arrow"
      />
    </Button>
  );
};

export default ActionButton;
